import * as React from 'react';
import { __ } from 'react-i18n/lib';
import { ContentModal } from './constants';
import { StoreDetailBase } from '../../_layout/Stores/StoreDetailBase';

interface ModalProps {
  shopDetail: any;
  onCloseButtonClick?: (event) => void;
}

const ShopModal = (props: ModalProps) => {
  const { onCloseButtonClick } = props;
  return (
    <ContentModal
      title={''}
      body={<StoreDetailBase detail={props.shopDetail} />}
      onCloseButtonClick={onCloseButtonClick}
    />
  );
};

export default ShopModal;
